(function() {
  var banner = document.getElementById("freeGiftBanner");
  if (!banner) return;

  var giftSku = banner.dataset.giftSku;
  var dataUrl = banner.dataset.giftDataUrl;
  var variantGiftMap = null;
  var currentGiftVariantId = null;
  var fallbackInfo = null;
  var adding = false;
  var fgContent = document.getElementById("fgContent");
  var FALLBACK_KEY = "FALLBACK_GIFT_CARD";

  if (!dataUrl) return;

  try {
    if (banner.dataset.variantGiftMap) variantGiftMap = JSON.parse(banner.dataset.variantGiftMap);
  } catch(e) {}

  function renderBanner(info) {
    if (!info || !fgContent) return;
    currentGiftVariantId = parseInt(info.variant_id || info.v);
    var price = parseFloat(info.price || info.p || 0).toFixed(2);
    var title = info.title || info.t || "";
    var image = info.image || info.i || "";

    fgContent.innerHTML = '<div class="ukcl-fg">' +
      '<img class="ukcl-fg__img" id="fgImage" src="' + image + '" alt="' + title + '">' +
      '<div class="ukcl-fg__info">' +
        '<div class="ukcl-fg__label">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="#028a7e"><path d="M20 6h-2.18c.11-.31.18-.65.18-1a3 3 0 0 0-3-3c-1.05 0-1.95.56-2.47 1.37L12 4.13l-.53-.76A2.99 2.99 0 0 0 9 2a3 3 0 0 0-3 3c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"/></svg>' +
          'FREE GIFT INCLUDED</div>' +
        '<div class="ukcl-fg__title" id="fgTitle">' + title + '</div>' +
        '<div class="ukcl-fg__worth"><s>&pound;' + price + '</s><span class="ukcl-fg__free">FREE</span> with this purchase</div>' +
      '</div></div>';
    fgContent.style.display = "block";
  }

  function checkVariantAvailability(variantId, callback) {
    if (!variantId) { callback(false); return; }
    fetch("/variants/" + variantId + ".js")
      .then(function(r) {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(function(v) { callback(v.available); })
      .catch(function() { callback(false); });
  }

  function showGiftOrFallback(info, giftData) {
    fallbackInfo = giftData ? giftData[FALLBACK_KEY] : null;

    if (!info || !(info.variant_id || info.v)) {
      if (fallbackInfo) renderBanner(fallbackInfo);
      return;
    }

    checkVariantAvailability(info.variant_id || info.v, function(available) {
      if (available === true) {
        renderBanner(info);
      } else if (fallbackInfo) {
        renderBanner(fallbackInfo);
      }
    });
  }

  fetch(dataUrl).then(function(r) {
    return r.json();
  }).then(function(data) {
    fallbackInfo = data[FALLBACK_KEY];
    var params = new URLSearchParams(window.location.search);
    var vid = params.get("variant") || (banner.dataset.currentVariantId || "");

    if (variantGiftMap && vid && variantGiftMap[vid]) {
      showGiftOrFallback(variantGiftMap[vid], data);
    } else if (data[giftSku]) {
      showGiftOrFallback(data[giftSku], data);
    } else if (data[FALLBACK_KEY]) {
      renderBanner(data[FALLBACK_KEY]);
    }

    document.addEventListener("change", function(e) {
      if (e.target && (e.target.name === "id" || (e.target.closest && e.target.closest("[data-variant-input]")))) {
        var v = e.target.value;
        if (variantGiftMap && variantGiftMap[v]) {
          showGiftOrFallback(variantGiftMap[v], data);
        }
      }
    });

    var lastV = "";
    setInterval(function() {
      var v = new URLSearchParams(window.location.search).get("variant");
      if (v && v !== lastV) {
        lastV = v;
        if (variantGiftMap && variantGiftMap[v]) showGiftOrFallback(variantGiftMap[v], data);
      }
    }, 500);

    function addGift() {
      if (adding || !currentGiftVariantId) return;
      adding = true;
      fetch("/cart.js").then(function(r) { return r.json(); }).then(function(cart) {
        var giftItem = null;
        var fallbackItem = null;
        var fallbackId = fallbackInfo ? parseInt(fallbackInfo.variant_id || fallbackInfo.v) : null;

        cart.items.forEach(function(i) {
          if (i.variant_id === currentGiftVariantId) giftItem = i;
          if (fallbackId && i.variant_id === fallbackId) fallbackItem = i;
        });

        if (giftItem && giftItem.quantity > 1) {
          fetch("/cart/change.js", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({id: giftItem.key, quantity: 1})
          }).then(function() { adding = false; }).catch(function() { adding = false; });
        } else if (!giftItem && !fallbackItem) {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({items: [{id: currentGiftVariantId, quantity: 1, properties: {"_free_gift": "true"}}]})
          }).then(function(r) {
            if (!r.ok && fallbackId) {
              return fetch("/cart/add.js", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({items: [{id: fallbackId, quantity: 1, properties: {"_free_gift": "true", "_fallback": "true"}}]})
              });
            }
            return r;
          }).then(function() { adding = false; }).catch(function() {
            if (fallbackId) {
              fetch("/cart/add.js", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({items: [{id: fallbackId, quantity: 1, properties: {"_free_gift": "true", "_fallback": "true"}}]})
              }).then(function() { adding = false; }).catch(function() { adding = false; });
            } else {
              adding = false;
            }
          });
        } else {
          adding = false;
        }
      }).catch(function() { adding = false; });
    }

    if (window.location.pathname === "/cart") {
      setInterval(addGift, 2000);
    }

    var origFetch = window.fetch;
    window.fetch = function(url, opts) {
      var result = origFetch.apply(this, arguments);
      if (typeof url === "string" && url.includes("/cart/add") && opts && opts.body) {
        var b = typeof opts.body === "string" ? opts.body : "";
        if (!b.includes("_free_gift") && currentGiftVariantId && !b.includes(String(currentGiftVariantId))) {
          result.then(function() { setTimeout(addGift, 600); });
        }
      }
      return result;
    };
  }).catch(function(e) { console.error("Gift data fetch failed:", e); });
})();
